export const bigRangeMeasure: number = 1500;

export const smallRangeMeasure: number = 500;